import React from 'react';
import { useSession } from 'src/SessionContext';
import ContainerSpinner from 'src/ui-components/ContainerSpinner';
import ClientView from './components/ClientView';

const ClientPage: React.FC = () => {
  const { session, loading } = useSession() || {};
  const { dayliteId } = session || {};

  if (loading || !dayliteId) {
    return <ContainerSpinner />;
  }

  return <ClientView clientId={dayliteId} />;
};

export default ClientPage;
